import React from 'react';

import { Footer, Link, Typography } from '@agco-onedigital/ecosystem-lib-web-components';
import { FormattedMessage, useIntl } from 'react-intl';

import { commonMessages } from 'messages';
import { EPreAuthRoutes } from './types';
import { messages } from './Router';
import { ContentWrapper } from './styles';
import { ContentReWrapper, StyledLogo, Wrapper } from './LoginError.styles';
import { useLaunchDarkly } from '../../store/LaunchDarkly';
import { handleLogoutRedirect } from '../../utils/msalConfiguration/utils';

const loginMessages = commonMessages.authTemplates.login;

const linkToLoginFactory = (logout: () => void) => (chunks: React.ReactNode) => (
  <Link
    variant="primary"
    size="lg"
    href={EPreAuthRoutes.HOME}
    onClick={e => {
      e.preventDefault();
      logout();
    }}
  >
    {chunks}
  </Link>
);

const LoginSyncWait = () => {
  const { formatMessage } = useIntl();
  const launchDarkly = useLaunchDarkly();

  const logout = async () => {
    await handleLogoutRedirect(launchDarkly);
  };

  return (
    <Wrapper>
      <ContentWrapper>
        <ContentReWrapper>
          <StyledLogo brand="agco" variant="primary" mode="light" />
          <Typography.Body size="lg" style={{ fontWeight: 'bold' }}>
            {formatMessage(loginMessages.loginSyncWaitTitle)}
          </Typography.Body>
          <Typography.Body size="lg">{formatMessage(loginMessages.loginSyncWaitDescription)}</Typography.Body>
          <Typography.Body size="lg">
            <FormattedMessage {...loginMessages.loginSyncWaitGoBack} values={{ link: linkToLoginFactory(logout) }} />
          </Typography.Body>
        </ContentReWrapper>
      </ContentWrapper>
      <Footer messages={messages} />
    </Wrapper>
  );
};

export default LoginSyncWait;
